import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { inject } from '@angular/core';
import { PostService } from '@app/src/app/modules/post/service/post.service';
import { PostGuard } from '@app/src/app/modules/post/classes/default/guard/post-guard';

export default {
  path: 'blog',
  data: {
    titlePrefix: 'Posts',
  },
  children: [
    {
      path: '',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/public/post-list/post-list').then(
          (m) => m.PostList,
        ),
      canActivate: [],
      resolve: {},
    },
    {
      path: ':category/:post',
      loadComponent: () =>
        import('@app/src/app/modules/post/views/public/post-show/post-show').then(
          (m) => m.PostShow,
        ),
      canActivate: [PostGuard()],
      resolve: {
        item: (route: ActivatedRouteSnapshot) =>
          inject(PostService).fetchBySlug(
            route.paramMap.get('post'),
            route.paramMap.get('category'),
          ),
      },
    },
  ],
} as Route;
